module.exports = __webpack_public_path__ + "static/media/airport.07e8f490.png";